/* eslint-disable no-extra-parens */
/* eslint-disable react/display-name */
import React, { memo } from  'react';
import styled from 'styled-components';
import { Subnavigation } from '../common/subnavigation/subnavigation';
import { reduxConnect } from '../../common';

import { translate, forecastRoutes } from  '../../common/translation/translate';
import { IStoreState } from '../common/interfaces/types';

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { appState } = storeState?.appState || {};
    const { pageId, user, routePath, enable10DayForecastPageOnWeb2, enableHourlyForecastPageOnWeb2 } = appState || {};
    const { SlugName: activeLocationSlug } = user?.ActiveLocation?.Locality || {};
    return {
        routePath,
        pageId,
        activeLocationSlug,
        enable10DayForecastPageOnWeb2,
        enableHourlyForecastPageOnWeb2
    };
};

const mapDispatchToProps = {};

const nowPageId = 'forecasts/current';
const hourlyPageId = 'forecasts/hourly';
const dailyPageId = 'forecasts/daily';

const localizedRoutePaths = {
    now: '/weather-forecast/now/:location',
    hourly: '/weather-forecast/hourly/:location',
    daily: '/weather-forecast/10-day-weather/:location'
} as const;

interface ForecastNavigationProps {
    pageId: string;
    activeLocationSlug: string;
    routePath: string;
    enable10DayForecastPageOnWeb2: boolean;
    enableHourlyForecastPageOnWeb2: boolean;
}

export const ForecastNavigation = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ 
    pageId, 
    activeLocationSlug,
    enable10DayForecastPageOnWeb2,
    enableHourlyForecastPageOnWeb2,
    routePath }: ForecastNavigationProps) => {
    
    const isLocalizedPage = (routePath === localizedRoutePaths.now)
        || (routePath === localizedRoutePaths.hourly)
        || (routePath === localizedRoutePaths.daily);
    
    let dailyForecastPageLink = isLocalizedPage && activeLocationSlug ? `${forecastRoutes.tenDay}${activeLocationSlug}` : forecastRoutes.tenDay;

    if (enable10DayForecastPageOnWeb2) {
        if (!isLocalizedPage) {
            dailyForecastPageLink = '/weather-forecast/10-day-weather';   
        }
    }
    
    let hourlyForecastPageLink = activeLocationSlug && isLocalizedPage ? `${forecastRoutes.hourly}${activeLocationSlug}` : forecastRoutes.hourly;

    if (enableHourlyForecastPageOnWeb2) {
        if (!isLocalizedPage) {
            hourlyForecastPageLink = '/weather-forecast/hourly';   
        }
    }
    
    return (
        <Container>
            <Subnavigation
                isActive={pageId === nowPageId}
                text={translate('now')}
                url={isLocalizedPage && activeLocationSlug ? `${forecastRoutes.now}${activeLocationSlug}` : forecastRoutes.now}
            />
            <Subnavigation
                isActive={pageId === hourlyPageId}
                text={translate('hourly')}
                url={hourlyForecastPageLink}
                linkToWeb2={enableHourlyForecastPageOnWeb2}
            />
            <Subnavigation
                isActive={pageId === dailyPageId}
                text={translate('tenDay')}
                linkToWeb2={enable10DayForecastPageOnWeb2}
                url={dailyForecastPageLink}
            />
        </Container>
    );
}));

const Container = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px 0;
`;

